<template>
	<v-text-field
					v-bind="$attrs"
					v-on="$listeners"
					color="accent"
					:name="name"
					:data-tabordername="tabOrderName || name"
					@keydown="$emit('keydown', $event)"
					@keydown.native="$checkForTabOrderEvent($event)"
					@keyup="$emit('keyup', $event)"
					ref="field"
					autocomplete="off"
					:autofocus="$autofocus"
	></v-text-field>
</template>

<script>
import {mobileAppAutofocusMixin} from '../mixins/mobileApp/mobileAppAutofocusMixin.js';

export default {
	name: 'SimpleTextInput',

	mixins: [mobileAppAutofocusMixin],

	methods: {
		focus() {
			if(this.isWebApp) {
				this.$refs.field.focus();
			}
		},

		blur() {
			this.$refs.field.blur();
		},
	},

	props: ['name', 'tabOrderName'],
}
</script>

<style scoped>

</style>
